import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * The investigation brief, collapsed by default.
 *
 * Rendered as real markdown (`react-markdown` + gfm, the same pair the CRM's
 * AI surfaces use) — the model writes headings, bold labels and inline
 * citation links, and as preformatted text every one of those arrived as
 * literal `##` and `[title](url)` noise the reader had to parse by eye.
 *
 * Citations open in a new tab: a brief is full of vendor docs and status
 * pages, and following one must never navigate the admin out of the incident
 * it is reading.
 */
export function CollapsedBrief({ markdown }: { markdown: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div
        className={`prose prose-sm max-w-none text-content-primary break-words
          prose-headings:mt-3 prose-headings:mb-1 prose-p:my-1
          prose-ul:my-1 prose-li:my-0.5 ${
            open ? "" : "max-h-32 overflow-hidden"
          }`}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            // `children` is passed explicitly rather than left in the spread:
            // jsx-a11y cannot see content arriving through `{...props}` and
            // reports the anchor as empty.
            a: ({ children, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
          }}
        >
          {markdown}
        </ReactMarkdown>
      </div>
      <button
        onClick={() => setOpen((o) => !o)}
        className="text-xs font-medium text-brand-primary hover:text-brand-primary-hover mt-1"
      >
        {open ? "Collapse" : "Expand"}
      </button>
    </div>
  );
}
